const pagination = {
  data () {
    return {
      page: 1,
      rowsPerPageItems: [10, 25, 50, 100],
      rowsPerPage: 25,
      totalItems: 0,
      pagination: {
        rowsPerPage: -1,
        sortBy: 'created_at',
        descending: true,
        page: 1,
        totalPages: 0
      }
    }
  },

  computed: {
    sortBy () {
      return this.pagination.sortBy
    },

    descending () {
      return this.pagination.descending
    },

    pages () {
      if (this.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      this.pagination.totalPages = Math.ceil(this.totalItems / this.rowsPerPage)
      const pages = []

      for (let i = 1; i <= this.pagination.totalPages; i++) {
        pages.push(i)
      }

      return pages
    }
  },

  watch: {
    page () {
      this.updateTable()
    },

    rowsPerPage () {
      this.goToFirstPage()
    },

    sortBy () {
      this.goToFirstPage()
    },

    descending () {
      this.goToFirstPage()
    }
  },

  methods: {
    async updateTable () {
      console.log('Please implement this method to update the data table')
    },

    filterTable () {
      this.goToFirstPage()
    },

    goToFirstPage () {
      if (this.page === 1) {
        this.updateTable()
        return
      }

      this.page = 1
    }
  }
}

export default pagination
